<script setup lang="ts">
	import type { NuxtError } from "#app";
	import { toFarsiNumber } from "~/utils";

	const props = defineProps({
		// eslint-disable-next-line vue/require-default-prop
		error: Object as () => NuxtError,
	});
</script>

<template>
	<div class="flex w-screen h-screen flex-col items-center justify-center">
		<h1>{{ toFarsiNumber(props.error?.statusCode) }}</h1>
		<NuxtLink to="/">
			<button class="text-dark">بازگشت به خانه</button>
		</NuxtLink>
	</div>
</template>

<style scoped>
	h1 {
		color: black;
		margin-bottom: 1em;
		font-weight: bold;
		font-size: 32px;
	}
</style>
